import { Role } from "@/interfaces/Role";
import { RouteRecordRaw } from "vue-router";
import AppLayout from "@/layouts/AppLayout.vue";

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/admin/dashboard/overview/:clientId?",
        name: "DashboardOverview",
        component: () => import("@/views/Dashboards/Dashboards.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Admin,
          icon: "pi pi-chart-bar",
          label: "navigation.overview",
          title: "titles.dashboardOverview",
          group: "Dashboard",
          order: 1,
        },
      },
      {
        path: "/admin/dashboard/sales-overview/:clientId?",
        name: "SalesOverview",
        component: () => import("@/views/Dashboards/SalesOverview.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Admin,
          icon: "pi pi-chart-line",
          label: "navigation.salesOverview",
          title: "titles.salesOverview",
          group: "Dashboard",
          order: 2,
        },
      },
      {
        path: "/admin/dashboard/profit-loss/:clientId?",
        name: "ProfitLoss",
        component: () => import("@/views/Dashboards/ProfitLoss.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Admin,
          icon: "pi pi-dollar",
          label: "navigation.profitLoss",
          title: "titles.profitLoss",
          group: "Dashboard",
          order: 3,
        },
      },
      {
        path: "/admin/dashboard/product-overview/:clientId?",
        name: "ProductOverview",
        component: () => import("@/views/Dashboards/ProductOverview.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Admin,
          icon: "pi pi-shopping-bag",
          label: "navigation.productOverview",
          title: "titles.productOverview",
          group: "Dashboard",
          order: 4,
        },
      },
      {
        path: "/admin/dashboard/product-summary/:clientId?",
        name: "ProductSummary",
        component: () => import("@/views/Dashboards/ProductSummary.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Admin,
          icon: "pi pi-list",
          label: "navigation.productSummary",
          title: "titles.productSummary",
          group: "Dashboard",
          order: 5,
        },
      },

      {
        path: "/admin/users",
        name: "ManageUsers",
        component: () => import("@/views/Users/Users.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Admin,
          icon: "pi pi-users",
          label: "navigation.manageUsers",
          title: "titles.manageUsers",
          group: "Users",
          order: 6,
        },
      },
      {
        path: "/admin/profile/settings",
        name: "Settings",
        component: () => import("@/views/Profile/Profile.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Admin,
          icon: "pi pi-cog",
          label: "navigation.settings",
          title: "titles.settings",
          group: "Profile",
          order: 7,
        },
      },
      {
        path: "/admin/tools/ad-cheker/:clientId?",
        name: "AdminAdCheker",
        component: () => import("@/views/Tools/AdCheker.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Admin,
          icon: "pi pi-cog",
          label: "navigation.adCheker",
          title: "titles.adCheker",
          group: "Tools",
          order: 8,
        },
      },
    ],
  },
];
